import React, { useEffect } from "react";
import user from "../../assets/images/users/8.jpg";
import { Breadcrumb, Card, Col, Row, Tab, Table, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setUserLists } from "../../redux/features/users.slice";
import { setCompanyName } from "../../redux/features/company.slice";
import { ApiRequest } from "../../api";

function Company() {
  const dispatch = useDispatch();
  const { userLists } = useSelector((state) => state.user);
  const { companyName, companyTrigger } = useSelector((state) => state.company);

  /*========= GET COMPANY DATA START =========*/
  useEffect(() => {
    ApiRequest.getCompanyInfo({
      SystemCompanyId: localStorage.getItem("SystemCompanyId"),
    }).then((response) => {
      dispatch(setCompanyName({ companyName: response.companyName }));
    });
    ApiRequest.getUsers({
      SystemCompanyId: localStorage.getItem("SystemCompanyId"),
    })
      .then((response) => {
        dispatch(setUserLists({ userLists: response }));
      })
      .catch((error) => {
        console.log(error);
      });
  }, [companyTrigger]);
  /*========= GET COMPANY DATA END =========*/

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Firma Bilgileri</h1>
          <Breadcrumb className="breadcrumb">
            <Breadcrumb.Item className="breadcrumb-item" href="#">
              Anasayfa
            </Breadcrumb.Item>
            <Breadcrumb.Item
              className="breadcrumb-item active breadcrumds"
              aria-current="page"
            >
              Firma Bilgileri
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <Row id="user-profile">
        <Col lg={12}>
          <Card className=" bg-transparent shadow-none border-0">
            <Card.Body className=" bg-white">
              <div className="wideget-user">
                <Row>
                  <Col lg={12} md={12} xl={6}>
                    <div className="wideget-user-desc d-sm-flex">
                      <div className="wideget-user-img">
                        <img className="" src={user} alt="img" />
                      </div>
                      <div className="user-wrap">
                        <h4 className="text-capitalize">{companyName}</h4>
                        <h6 className="text-muted mb-3">
                          Üyelik Tarihi: Temmuz 2020
                        </h6>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12} md={12} xl={6}>
                    <div className="text-xl-right mt-4 mt-xl-0">
                      <Link
                        to={`/Company/Edit`}
                        className="btn btn-primary me-1"
                      >
                        Bilgileri Düzenle
                      </Link>
                    </div>
                    <div className="mt-5">
                      <div className="main-profile-contact-list float-md-end d-md-flex">
                        <div className="me-5 mt-5 mt-md-0">
                          <div className="media">
                            <div className="media-icon bg-success me-3 mt-1">
                              <i className="fe fe-users  fs-20 text-white"></i>
                            </div>
                            <div className="media-body">
                              <span className="text-muted">Çalışan Sayısı</span>
                              <div className="fw-semibold fs-25">
                                {userLists.length}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Card.Body>
            <div className="border-top ">
              <div className="wideget-user-tab">
                <div className="tab-menu-heading">
                  <div className="tabs-menu1 profiletabs">
                    <Tabs
                      variant="Tabs"
                      defaultActiveKey="Profile"
                      id=" tab-51"
                      className="tab-content tabesbody "
                    >
                      <Tab eventKey="Profile" title="Bilgi Alanı">
                        <div className="tab-pane profiletab show">
                          <div id="profile-log-switch">
                            <Card>
                              <Card.Body className="bg-white">
                                <div className="media-heading">
                                  <h5>
                                    <strong>Firma Bilgileri</strong>
                                  </h5>
                                </div>
                                <div className="table-responsive p-1">
                                  <Table className="table row table-borderles mb-0">
                                    <tbody className="col-lg-12 col-xl-6 p-0">
                                      <tr>
                                        <td className="text-capitalize">
                                          <strong>Firma Adı : </strong>
                                          {companyName}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Company;
